import { useState, useEffect } from "react";


const AuthenticatePartner = () => {
  const [hmsServiceId, setHmsServiceId] = useState("24");
  const [message, setMessage] = useState("");
  

  // Function to make the API call
  const authenticateUser = async () => {
    try {
      const response = await fetch(
        `https://hms-g2gbera0bddsdugv.canadacentral-01.azurewebsites.net/auth/?hms_service_id=${hmsServiceId}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      const data = await response.json();

      if (response.ok) {
        localStorage.setItem("access_token", data.access_token);
        setMessage("Token received and stored successfully!");
        
      } else {
        setMessage(data.message || "Authentication failed");
      }
    } catch (error) {
      console.error("Error:", error);
      setMessage("Error occurred during authentication");
    }
  };

  
  useEffect(() => {
    authenticateUser();
  }, []); 

  

  return (
    <div className="p-4 max-w-md mx-auto">
      <h2 className="text-xl font-bold mb-4">Authenticate Partner</h2>

      <div className="mb-4">
        <input
          type="text"
          placeholder="Enter HMS Service ID"
          value={hmsServiceId}
          onChange={(e) => setHmsServiceId(e.target.value)}
          className="w-full p-2 border rounded"
        />
      </div>


      {message && (
        <div className="mt-4 p-2 bg-gray-100 rounded">
          <p>{message}</p>
        </div>
      )}
    </div>
  );
};

export default AuthenticatePartner;